import { faRightLong } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { DarkModeContext } from '../../../App';
import useProjects from '../../../Hooks/useProjects';
import Project from '../Project/Project';

const HomeProjects = () => {
    const [projects] = useProjects();
    // console.log(projects);
    const [darkMode, setDarkMode] = useContext(DarkModeContext);
    return (
        <div>
            <div id='' className=''>
                <h1 className={`py-4 flex flex-row pl-8 text-4xl ${darkMode ? 'text-blue-300' : 'text-accent'} font-bold text-left`}>My Recent <span> Projects</span></h1>
                
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-10 lg:px-12 px-4 pt-8 pb-8'>
                    {
                        projects.slice(0, 6).map(project => <Project
                            key={project.id}
                            project={project}
                        ></Project>)
                    }
                </div>
                <div className='flex justify-end mb-12 mr-12 items-center'>
                <Link to="/portfolio" className='text-right d-block text-secondary text-xl font-semibold'>see more </Link> <FontAwesomeIcon className='mt-1 ml-1 text-xl cursor-pointer text-secondary' icon={faRightLong} />
                </div>
            </div>
        </div>
    );
};

export default HomeProjects;